import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-02b82163"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bottomSheetOverlay" };
const _hoisted_2 = { class: "bottomSheet" };
const _hoisted_3 = { class: "MainTitle" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "serviceCenterItemsAddress text-left" }, "Choose Garage", -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "chooseGarageIcon" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M8.16651 9.4499C7.9508 9.21663 7.60031 9.21582 7.38368 9.44808C7.18673 9.65923 7.1682 9.99031 7.32853 10.224L7.38199 10.291L11.8281 15.0989C12.0248 15.3116 12.3334 15.331 12.5504 15.157L12.6126 15.099L17.0594 10.291C17.2751 10.0578 17.2744 9.68039 17.0578 9.44811C16.8608 9.23695 16.5533 9.2184 16.3369 9.39201L16.2749 9.44986L12.2201 13.8335L8.16651 9.4499Z",
            fill: "#1C1C1C"
        })
    ])
], -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "serviceCenterItemsAddress text-left" }, "Notes", -1));
const _hoisted_7 = { class: "btn-group" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "bottomSheetOverlay" };
const _hoisted_10 = { class: "bottomSheet mod" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "chooseGarageTitle" }, "Choose Garage", -1));
const _hoisted_12 = { class: "serviceCenterContainer" };
const _hoisted_13 = ["onClick"];
const _hoisted_14 = { class: "serviceCenterItemsTitle" };
const _hoisted_15 = { class: "serviceCenterItemsAddress" };
import DButton from "../button/SubmitButton.vue";
import { ref, onMounted, watch, computed } from "vue";
import SearchTextBox from "../search-text-box/SearchTextBox.vue";
import { getApiBaseUrl } from "../../apiConfig";
import axios from "axios";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BottomSheetGarage',
    props: {
        value: {
            type: String,
            default: "Are you sure you want to start the session?",
        },
    },
    emits: ["close", "start", "update:value"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const serviceCenterPopup = ref(false);
        const searchQuery = ref("");
        const noteRef = ref("");
        // const serviceCenterOptions = ref([]);
        const filterServiceCenterOptions = ref([]);
        const filteredServiceCenterOptions = ref([]);
        const selectedServiceCeter = ref();
        // Define the emit event
        const emit = __emit;
        const isClicked = ref(false);
        watch([selectedServiceCeter, noteRef], ([newValue, newNote]) => {
            if (newValue) {
                emit("update:value", { serviceCenter: newValue, note: newNote });
            }
        });
        // Emit an event when the "No" button is clicked
        function handleClose() {
            console.log("hell close");
            emit("close");
        }
        // Emit an event when the "Yes" button is clicked
        function handleStart() {
            console.log("hell start");
            isClicked.value = true; // Disable the button
            // Simulate an action (e.g., API call)
            setTimeout(() => {
                isClicked.value = false; // Re-enable the button if needed
            }, 60000); // Re-enable after 3 seconds
            emit("start");
        }
        function toggleService() {
            serviceCenterPopup.value = !serviceCenterPopup.value;
        }
        onMounted(async () => {
            try {
                // filterServiceCenterOptions.value = data;
                const baseUrl = getApiBaseUrl() || process.env.VUE_APP_BASE_URL;
                const response = await axios.get(`${baseUrl}/showroom/list`);
                console.log(response.data);
                if (response.data) {
                    console.log("data", response.data.data);
                    // Assuming the response returns an array of objects with `label` and `value`
                    // const data = response.data.data.map((reason) => ({
                    //   label: reason.name, // Assuming `name` is the reason text
                    //   value: reason.name, // Assuming `id` is the unique identifier
                    // }));
                    // checkboxOptions.value = data;
                    // filterCheckboxOptions.value = data;
                    const serviceCenterData = response.data.data.filter((data) => data.isServiceCenter);
                    filterServiceCenterOptions.value = serviceCenterData;
                    filteredServiceCenterOptions.value = serviceCenterData;
                }
            }
            catch (error) {
                console.error("Error fetching reasons:", error);
            }
        });
        // serviceCenterOptions.value = data;
        watch(searchQuery, () => {
            const filteredData = computed(() => {
                if (!searchQuery.value)
                    return filterServiceCenterOptions.value;
                return filterServiceCenterOptions.value.filter((option) => option.title.toLowerCase().includes(searchQuery.value.toLowerCase()));
            });
            filteredServiceCenterOptions.value = filteredData.value;
        });
        function selectedItem(data) {
            console.log("data", data);
            selectedServiceCeter.value = data;
            toggleService();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(props.value), 1),
                    _hoisted_4,
                    _createElementVNode("div", {
                        class: _normalizeClass(`chooseGarage ${selectedServiceCeter.value ? 'selected' : ''}`),
                        onClick: toggleService
                    }, [
                        _createElementVNode("div", null, _toDisplayString(selectedServiceCeter.value ? selectedServiceCeter.value.title : "Choose Garage"), 1),
                        _hoisted_5
                    ], 2),
                    _hoisted_6,
                    _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "Note",
                            class: "input",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((noteRef).value = $event))
                        }, null, 512), [
                            [_vModelText, noteRef.value]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(DButton, {
                            value: "No",
                            secondary: "",
                            onClick: handleClose,
                            disabled: isClicked.value
                        }, null, 8, ["disabled"]),
                        _createVNode(DButton, {
                            value: "Yes",
                            primary: "",
                            onClick: handleStart,
                            disable: isClicked.value || !selectedServiceCeter.value
                        }, null, 8, ["disable"])
                    ]),
                    (serviceCenterPopup.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _hoisted_11,
                                    _createVNode(SearchTextBox, {
                                        value: searchQuery.value,
                                        "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((searchQuery).value = $event)),
                                        placeholder: "Search Reason"
                                    }, null, 8, ["value"]),
                                    _createElementVNode("div", _hoisted_12, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredServiceCenterOptions.value, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: "serviceCenterItems",
                                                key: index,
                                                onClick: ($event) => (selectedItem(item))
                                            }, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1),
                                                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.address.address), 1)
                                                ])
                                            ], 8, _hoisted_13));
                                        }), 128))
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
